// ink-component
import React, { HTMLAttributes, ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import { EquityVariants, FeedbackVariants } from '../_common/Types/GlobalTypes';
import getGlobalProps from '../../helpers/constants/global-props';
import { bubbleTypes, StyledBubble } from './styles';

export interface BubbleProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'type'> {
  /** Semantic variants, based on intent */
  variant?:
    | EquityVariants
    | Extract<
        FeedbackVariants,
        | 'feedback-positive'
        | 'feedback-negative'
        | 'feedback-notice'
        | 'feedback-neutral'
        | 'feedback-pending'
        | 'feedback-informational'
        | 'feedback-staff'
      >;
  /** Defines the type of bubble (color or purpose) */
  type?: keyof typeof bubbleTypes;
  /** Small text inside the bubble */
  children: ReactNode;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
}

const globalProps = getGlobalProps({});

/**
 * @purpose Highlights one or two words for more visibility
 * @categories accessory
 * @aka pill, badge
 */
function Bubble(props: BubbleProps) {
  const { style, className, variant, type, ...otherProps } = props;

  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        type,
        variant,
      })}
    >
      <StyledBubble {...otherProps} {...globalProps} data-testid={props['data-testid']}>
        {props.children}
      </StyledBubble>
    </ThemeProvider>
  );
}

Bubble.defaultProps = {
  type: 'blue',
  children: undefined,
  'data-testid': undefined,
};

Bubble.displayName = 'Bubble';

export default Bubble;
